<template>
  <transition-group class="hero-container" name="blur" tag="div">
      <div v-show="currentSrc === null" :key="0" class="placeholder blur-transition" key="placeholder"></div>
      <canvas v-show="currentSrc === loResSrc" :key="1" height="17" width="27" key="canvas" class="blur-transition"></canvas>
      <div v-show="currentSrc === hiResSrc" :key="2" class="hero blur-transition" v-bind:style="{ 'background-image': 'url(' + hiResSrc + ')' }">
        <div class="overlay"></div>
        <!-- <h1>{{ title }}</h1>
        <div class="underline" :style="{ backgroundColor: color }"></div> -->
      </div>
      <div class="hero__text" :key="title">
        <h1 tabindex="-1">{{ title }}</h1>
        <div class="underline" :style="{ backgroundColor: color }"></div>
      </div>
  </transition-group>
</template>

<script>
export default {
  name: 'Hero',
  props: [
    'title',
    'color',
    'loResSrc',
    'hiResSrc'
  ],
  data () {
    return {
      currentSrc: null
    }
  },
  mounted () {
    var loResImg
    var hiResImg
    var that
    var context
    loResImg = new Image()
    hiResImg = new Image()
    that = this
    context = this.$el.getElementsByTagName('canvas')[0].getContext('2d')

    loResImg.onload = function () {
      context.drawImage(loResImg, 0, 0)
      if (that.currentSrc === null) {
        that.currentSrc = that.loResSrc
      }
    }
    hiResImg.onload = function () {
      that.currentSrc = that.hiResSrc
    }
    loResImg.src = that.loResSrc
    hiResImg.src = that.hiResSrc

    document.getElementsByTagName('h1')[0].focus()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hero-container {
  position: relative;
  height: calc(100vh - 56px);
  min-height: 420px;
  width: 100%;
  background-color: #000;
  overflow: hidden;
}
canvas, .placeholder {
  position: absolute;
  height: calc(100vh - 56px);
  min-height: 420px;
  width: 100%;
  background-size: cover;
  background-position: center
}
.placeholder {
  background-color: rgba(0,0,0,.5);
}
canvas {
filter: blur(10px);
}
.blur-transition {
  transition: opacity linear .4s 0s;
  opacity: 1;
}
.blur-enter, .blur-leave {
  opacity: 0;
}

.hero {
  position: relative;
  height: calc(100vh - 56px);
  min-height: 420px;
  width: 100%;
  background-size: cover;
  background-position: center;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 50px;
  padding-right: 50px;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  background-color: #323233;
  opacity: 0.6;
  z-index: 2;
}
h1 {
  text-align: center;
  color: #FFF;
  z-index: 3;
  width: 100%;
  outline: none;
  &:focus {
    outline: none;
  }
}
.underline {
  display: block;
  width: 150px;
  height: 4px;
  z-index: 3;
  margin-top: 25px;
}
.hero__text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 56px);
  min-height: 420px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 50px;
  padding-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Hero.vue